<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import { RouterView, useRoute } from 'vue-router';
import AppLayout from './views/AppLayout.vue';
import { useUserStore, type User } from './stores/user';

const userStore = useUserStore();
const user = ref<User | undefined>(userStore.user);

onMounted(async () => {
  user.value = await userStore.fetchCurrentUser();
});

const routes = useRoute();
const currentRoute = ref<string | undefined>(routes.name?.toString());
watch(
  () => routes.name,
  (newVal, _oldVal) => {
    currentRoute.value = newVal?.toString();
  },
);
</script>

<template>
  <AppLayout :user="user">
    <RouterView />
  </AppLayout>
  <!-- <div class="content" :class="{ 'dark-mode': themeRef === 'dark-mode' }">
    <div class="theme-control">
      <button :disabled="themeRef === 'dark-mode'" @click="darkClicked">Dark Mode</button>
      |
      <button :disabled="themeRef !== 'dark-mode'" @click="lightClicked">Light Mode</button>
    </div>
    <div id="wrap">
      <header>
        <h1>
          <a href="/" title="Challenge this">
            <router-link to="/">Challenge <span>this</span></router-link>
          </a>
        </h1>
        <div class="link-box">
          <a class="top-link" title="Rules">
            <router-link to="/rules" :class="{ current: 'rules' === currentRoute }">
              Rules
            </router-link>
          </a>
          <a class="top-link" title="Games"
            ><router-link to="/games" :class="{ current: 'games' === currentRoute }">
              Games
            </router-link>
          </a>
        </div>

        <UserCard :user="user" />
      </header>
      <RouterView />
      <footer class="credits">
        <a
          href="https://www.youtube.com/@OlexaYT"
          title="Olexa's Youtube"
          target="_blank"
          class="olexa"
        >
          <img src="/images/olexa-logo.png" alt="Olexa" /> Inspired by Olexa's Pyramid</a
        >
        <a
          href="https://www.twitch.tv/laserbelch"
          title="LaserBelch's Twitch"
          target="_blank"
          class="twitch"
        >
          <img src="/images/laser-avatar.png" alt="LaserBelch" />
          twitch.tv/laserbelch
        </a>
      </footer>
      <div class="notification-queue">
        <NotificationQueue />
      </div>
    </div>
</div> -->
</template>

<style scoped>
.content {
  min-height: 100vh;
  height: 100%;
  width: 100%;
  background-color: var(--color-light-orange);
  color: var(--color-orange);
  position: relative;
}

.dark-mode {
  background-color: var(--color-slate);
}

.theme-control {
  top: 15px;
  right: 45px;
  position: absolute;
  z-index: 99;
}

.theme-control button {
  background: transparent;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 1px;
}
.theme-control button:disabled {
  color: #999;
  cursor: default;
}

header {
  padding: 50px;
  display: flex;
  justify-content: space-between;
}

h1 {
  font-size: 70px;
  line-height: 64px;
  text-transform: uppercase;
  margin-right: -1em;
}
h1 a {
  color: var(--color-orange);
}

h1 span {
  display: block;
  letter-spacing: 1em;
}

.link-box {
  position: absolute;
  left: 50%;
  margin-top: 15px;
  display: flex;
  transform: translateX(-50%);
}
.top-link {
  text-transform: uppercase;
  font-size: 20px;
  letter-spacing: 2px;
}
.top-link a {
  color: var(--color-orange);
  padding: 15px;
}

.top-link a.current {
  color: #999;
  cursor: default;
}

#app {
  overflow-x: hidden;
}

#wrap {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-bottom: 80px;
  position: relative;
}
.credits {
  position: absolute;
  flex-direction: row;
  bottom: 0;
  left: 25px;
  padding: 20px 0 14px;
  display: flex;
  gap: 3rem;
  font-size: 14px;
  letter-spacing: 1px;
}
.credits .olexa {
  text-transform: uppercase;
}

.credits a {
  border-color: var(--color-blue);
  border-width: 0;
}

.credits a img {
  width: 50px;
  background-color: var(--color-light-orange);
  border-color: inherit;
  border-style: solid;
  border-width: 3px;
  border-radius: 8px;
  margin-right: 10px;
}

.credits a:hover {
  color: var(--color-orange);
  border-color: var(--color-orange);
}

@media screen and (max-width: 1200px) {
  #wrap .link-box {
    position: static;
    transform: none;
  }
}
@media screen and (max-width: 1050px) {
  header {
    padding: 35px;
  }
  #app .theme-control {
    right: 29px;
    top: 7px;
  }
  .credits {
    margin-top: 35px;
  }
}
@media screen and (max-width: 800px) {
  #wrap header {
    flex-direction: column;
  }
  #wrap h1 {
    font-size: 17vw;
    line-height: 17vw;
    order: 3;
    margin: 20px 0 0;
    overflow: hidden;
  }
  #wrap header .twitch {
    order: 1;
    padding: 15px 0 15px 70px;
    background-position: left center;
  }
  #wrap .link-box {
    margin-top: 25px;
    order: 2;
  }
  #wrap .top-link a {
    padding: 15px 15px 15px 0;
  }
}
@media screen and (max-width: 500px) {
  #app .theme-control {
    left: 50%;
    right: auto;
    transform: translateX(-50%);
  }
  #wrap header .twitch {
    display: inline-block;
    margin: 10px auto 0;
    padding: 10px 0 10px 50px;
    background-size: auto 100%;
  }
  #wrap .link-box {
    margin: 25px auto 0;
  }
  .slot-machine {
    max-width: 65vw;
  }
  #wrap .slot {
    width: 65vw;
    height: 97.5vw;
  }
  #wrap .lever {
    left: -55px;
  }
  #wrap h1 {
    font-size: 16vw;
    line-height: 15.5vw;
  }
}
</style>
